module.exports = __webpack_public_path__ + "static/blogpic.95a12de4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/blogpic.jpg
// module id = 3045
// module chunks = 174994552580003